export default {
  mode: 'directLink',
  
  experimentId: '287',
  serverUrl: 'https://magpie-demo.herokuapp.com/',
  serverAppURL: "https://magpie-demo.herokuapp.com/api/submit_experiment/",
  contactEmail: 'pi.schwarz@student.uni-tuebingen.de'
};
